export const StdAlert = (title, desc, onPress = () => { }) => {
    alert(`${title}\n${desc}`)
    if (onPress) onPress()
}